import { filter, mergeMap, ignoreElements, map, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';

import { TFavorite, TRemote, ASetFavorites } from '../actions';
import { Favorite } from '../entities';
import { of } from 'rxjs';

export const addFavoriteEpic = (action$, state$, { restApi }) =>
  action$.pipe(
    ofType(TFavorite.FAVORITE_ADD),
    mergeMap(({ payload }) => restApi.put(`/favorite/${payload.id}?ngsw-bypass=true`)),
    map((favorite: Favorite) => ASetFavorites([...Object.values<Favorite>(state$.value.favorite), favorite]))
  );

export const removeFavoriteEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TFavorite.FAVORITE_REMOVE),
    mergeMap(({ payload }) => restApi.delete(`/favorite/${payload}?ngsw-bypass=true`)),
    ignoreElements(),
  );

export const fetchFavoritesEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => type === TFavorite.FETCH_FAVORITES || type === TRemote.SET_REMOTE),
    mergeMap(() => restApi.get('/favorite?ngsw-bypass=true').pipe(
      /**
       * There is a common handler for all errors.
      * However, we need to return an empty array in case of an error
      * to prevent the error from being propagated to the upper level.
      * If it is not handled here, this interrupts the flow if the API returns a 404.
       */
      catchError(() => of([])),
    )),
    map(ASetFavorites),
  );
